import React, { Component } from 'react';

export default ({
    fill,style, width, height
}) => (
    <svg fill={fill} 
        style={style}
        width={width}
        height={height}
    version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
	 viewBox="0 0 296.789 296.789">
<g>
	<path d="M55.093,110.761l6.544,17.743c0.246,0.668,0.882,1.111,1.593,1.111c0.711,0,1.347-0.443,1.593-1.111l6.544-17.743
		c5.297-14.364,16.62-25.687,30.983-30.983l17.743-6.544c0.667-0.246,1.11-0.882,1.11-1.593c0-0.711-0.443-1.347-1.11-1.593
		l-17.744-6.544c-14.363-5.297-25.686-16.619-30.982-30.982l-6.544-17.743c-0.246-0.667-0.882-1.11-1.593-1.11
		c-0.711,0-1.347,0.443-1.593,1.11l-6.544,17.743C49.796,46.885,38.474,58.207,24.11,63.504L6.366,70.048
		c-0.667,0.246-1.11,0.882-1.11,1.593c0,0.711,0.443,1.347,1.11,1.593l17.743,6.544C38.473,85.074,49.796,96.396,55.093,110.761z"/>
	<path d="M198.948,185.703l-17.742-6.543c-14.364-5.297-25.687-16.619-30.983-30.982l-6.544-17.743
		c-0.246-0.667-0.882-1.11-1.593-1.11c-0.711,0-1.347,0.443-1.593,1.11l-6.544,17.742c-5.297,14.364-16.62,25.686-30.983,30.983
		l-17.743,6.543c-0.667,0.246-1.11,0.882-1.11,1.593c0,0.711,0.443,1.347,1.11,1.593l17.744,6.545
		c14.363,5.297,25.685,16.619,30.982,30.982l6.544,17.744c0.246,0.667,0.882,1.11,1.593,1.11c0.711,0,1.347-0.443,1.593-1.11
		l6.544-17.744c5.297-14.363,16.619-25.686,30.982-30.982l17.744-6.545c0.667-0.246,1.11-0.882,1.11-1.593
		C200.059,186.585,199.615,185.949,198.948,185.703z"/>
	<path d="M290.778,109.811l-12.059-4.447c-9.761-3.6-17.456-11.295-21.056-21.056l-4.447-12.058c-0.168-0.453-0.6-0.755-1.083-0.755
		c-0.483,0-0.915,0.302-1.083,0.755l-4.446,12.057c-3.6,9.762-11.295,17.457-21.057,21.057l-12.058,4.447
		c-0.453,0.167-0.755,0.599-0.755,1.082s0.302,0.916,0.755,1.083l12.059,4.446c9.761,3.601,17.456,11.296,21.056,21.057l4.446,12.06
		c0.168,0.453,0.6,0.755,1.083,0.755c0.483,0,0.915-0.302,1.083-0.755l4.447-12.06c3.6-9.762,11.294-17.456,21.056-21.056
		l12.059-4.447c0.453-0.167,0.755-0.6,0.755-1.083S291.231,109.978,290.778,109.811z"/>
	<path d="M261.567,268.552l-8.412-3.103c-6.809-2.511-12.176-7.878-14.687-14.686l-3.103-8.41c-0.116-0.316-0.418-0.526-0.755-0.526
		s-0.639,0.21-0.755,0.526l-3.103,8.41c-2.511,6.809-7.878,12.176-14.686,14.686l-8.412,3.103c-0.316,0.116-0.526,0.418-0.526,0.755
		c0,0.337,0.21,0.639,0.526,0.755l8.411,3.103c6.81,2.511,12.177,7.879,14.688,14.688l3.103,8.411
		c0.116,0.316,0.418,0.526,0.755,0.526s0.639-0.21,0.755-0.526l3.103-8.411c2.511-6.809,7.878-12.177,14.688-14.688l8.411-3.103
		c0.316-0.116,0.526-0.418,0.526-0.755C262.094,268.97,261.884,268.668,261.567,268.552z"/>
	<path d="M199.533,26.726l-8.412-3.102c-6.809-2.511-12.176-7.878-14.686-14.687l-3.103-8.41C173.216,0.21,172.914,0,172.577,0
		c-0.337,0-0.639,0.21-0.755,0.526l-3.102,8.409c-2.511,6.809-7.879,12.177-14.688,14.688l-8.412,3.102
		c-0.316,0.116-0.526,0.418-0.526,0.755c0,0.337,0.21,0.639,0.526,0.755l8.411,3.103c6.81,2.511,12.178,7.879,14.689,14.689
		l3.102,8.41c0.116,0.316,0.418,0.526,0.755,0.526c0.337,0,0.639-0.21,0.755-0.526l3.103-8.411
		c2.511-6.81,7.878-12.177,14.688-14.687l8.411-3.103c0.316-0.116,0.526-0.418,0.526-0.755
		C200.06,27.144,199.85,26.842,199.533,26.726z"/>
	<path d="M96.359,251.26l-10.58-3.9c-8.564-3.158-15.316-9.91-18.476-18.475l-3.901-10.58c-0.147-0.397-0.526-0.662-0.95-0.662
		c-0.424,0-0.803,0.265-0.95,0.662l-3.901,10.579c-3.158,8.565-9.91,15.317-18.476,18.476l-10.578,3.9
		c-0.399,0.146-0.662,0.526-0.662,0.95c0,0.424,0.264,0.804,0.662,0.95l10.579,3.902c8.564,3.158,15.316,9.91,18.475,18.475
		l3.901,10.58c0.147,0.398,0.526,0.662,0.95,0.662c0.424,0,0.804-0.264,0.95-0.662l3.902-10.581
		c3.158-8.564,9.909-15.315,18.474-18.474l10.581-3.902c0.398-0.146,0.662-0.526,0.662-0.95
		C97.021,251.786,96.758,251.406,96.359,251.26z"/>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
)